import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

marked.setOptions({
    gfm: true,
    breaks: true,
});

@Pipe({
    name: 'markdown',
    standalone: true,
})
export class MarkdownPipe implements PipeTransform {
    private readonly _sanitizer = inject(DomSanitizer);

    transform(value: string | null | undefined): SafeHtml {
        if (value == null || value === '') {
            return this._sanitizer.bypassSecurityTrustHtml('');
        }
        const html = marked.parse(String(value), { async: false }) as string;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }
}
